import { useApiClient } from '@chilipiper/api-client/src/context'
import { UserAvailabilityApiClientV1 } from '@chilipiper/api-client/src/user-availability'
import { add, differenceInMinutes } from '@chilipiper/date-time'
import { queryOptions, skipToken, useQuery } from '@tanstack/react-query'

interface MeetingsAvailabilitySpanParams {
  tenantId?: string
  meetingTypeId?: string
  meetingTypeVersion: string
  intervalStartsAt?: string
}

const meetingsAvailabilitySpanQuery = ({
  userAvailabilityClient,
  tenantId,
  meetingTypeId,
  meetingTypeVersion = new Date().toISOString(),
  intervalStartsAt,
}: MeetingsAvailabilitySpanParams & {
  userAvailabilityClient: UserAvailabilityApiClientV1
}) => {
  return queryOptions({
    queryKey: [tenantId, meetingTypeId, 'user-availability/meetings-availability-span'],
    queryFn:
      tenantId && meetingTypeId
        ? () =>
            userAvailabilityClient
              .getMeetingsAvailabilitySpan(tenantId, {
                meetingTypeId,
                meetingTypeVersion,
              })
              .then(({ startsAt, duration }) => {
                const endsAt = add(new Date(startsAt), {
                  minutes: differenceInMinutes(new Date(parseInt(duration)), new Date(0)),
                }).toISOString()

                return { startsAt: intervalStartsAt ?? startsAt, endsAt }
              })
        : skipToken,
  })
}

export const useMeetingsAvailabilitySpan = (params: MeetingsAvailabilitySpanParams) => {
  const { userAvailability } = useApiClient()
  return useQuery(
    meetingsAvailabilitySpanQuery({ ...params, userAvailabilityClient: userAvailability })
  )
}
